/*
 * KNM-92: акции = дочерние RatePlan (parent != null).
 * Полный набор полей (name, parent, year, is_default) тот же, что у RatePlan.
 */
export type Discount = {
  id: number
  name: string
  parent: number | null
  is_default: boolean
  year: number
  discount: number
  discount_type: 'percent' | 'flat'
  room_categories: number[]
  start_date: string
  end_date: string
  min_nights: number
  missing_base_prices?: {
    room_category: number
    name: string
    dates: { start_date: string, end_date: string }[]
  }[]
}

export type GetDiscountsReq = {
  page?: number
  per_page?: number
  parent__isnull?: boolean
  is_default?: boolean
}

export type GetDiscountsRes = {
  count: number
  next: null | string
  previous: null | string
  total_pages: number
  results: Discount[]
}

export const GET_DISCOUNTS_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/'

export type AddDiscountsReq = {
  parent: number
  discount: number
  discount_type?: 'percent' | 'flat'
  room_categories: number[]
  start_date: string
  end_date: string
  min_nights: number
}

export type AddDiscountsRes = Discount

export const ADD_DISCOUNTS_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/'

export type UpdateDiscountsReq = Partial<Omit<Discount, 'id' | 'parent' | 'is_default' | 'year' | 'name'>>

export type UpdateDiscountsRes = Discount

export const UPDATE_DISCOUNTS_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/:discount_id/'

export type DeleteDiscountsReq = undefined

export type DeleteDiscountsRes = void

export const DELETE_DISCOUNTS_URL = '/v2/pms/accomodations/:accomodation_id/rate_plans/:discount_id/'
